import Chip from '@material-ui/core/Chip';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import withFormikFieldArray from '../withFormikFieldArray';

const withMultiSelectAutosuggest = (AutosuggestComponent) => {
   const InnerMultiSelectAutosuggest = (props) => {
      const [autosuggestValue, setAutosuggestValue] = useState('');
      const [selectedIdList, setSelectedIdList] = useState([]);

      useEffect(() => {
         if (props.value) {
            setSelectedIdList(props.value.map(({ id }) => id));
         }
      }, [JSON.stringify(props.value)]);

      const handleChangeAutosuggest = useCallback((suggestionSelected) => {
         if (!Number.isNaN(+(suggestionSelected?.id))) {
            setAutosuggestValue('');
            props.push(suggestionSelected);
         } else if (suggestionSelected?.id?.length) {
            setAutosuggestValue('');
            props.push(suggestionSelected);
         } else {
            setAutosuggestValue(suggestionSelected);
         }
      }, [props.push]);

      return (
         <div>
            <AutosuggestComponent
               handleChange={handleChangeAutosuggest}
               handleBlur={props.handleBlur}
               value={autosuggestValue}
               filterSuggestions={(suggestionItem) => {
                  return !selectedIdList.includes(suggestionItem?.id);
               }}
            />
            <div>
               {
                  lodash.isArray(props.value)
                  && (
                     props.value.map((item, idxItem) => {
                        return (
                           <div
                              className='my-1'
                              key={`${ item.id }`}
                           >
                              <Chip
                                 clickable
                                 size='small'
                                 label={item?.name}
                                 onDelete={() => {
                                    props.remove(idxItem);
                                 }}
                              />
                           </div>
                        );
                     })
                  )
               }
            </div>
         </div>
      );
   };

   InnerMultiSelectAutosuggest.propTypes = {
      value: PropTypes.arrayOf(PropTypes.shape({
         id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
         name: PropTypes.string.isRequired,
      })).isRequired,
      push: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
      handleBlur: PropTypes.func.isRequired,
   };

   InnerMultiSelectAutosuggest.defaultProps = {
   };

   return InnerMultiSelectAutosuggest;
};

export default (AutosuggestComponent) => withFormikFieldArray(withMultiSelectAutosuggest(AutosuggestComponent));
